export default __webpack_public_path__ + "static/media/assemblyH2.606dd3cd.png";